module.exports = __webpack_public_path__ + "static/media/Navigate Theme – Map – 1.6c937077.jpg";